const triggerEvent = (el, eventName, config = {}) => {
  let eventConfig = Object.assign({
    bubbles: true,
    cancelable: true
  }, config);

  let event = new Event(eventName, eventConfig);

  el.dispatchEvent(event);
}

export { triggerEvent };